import { useEffect } from "react";
import AOS from "aos";
import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";
import ContactFloat from "@/components/ContactFloat";
import IndustrySolutionSections from "@/components/IndustrySolutionSections";
import KnowledgeBaseMindMap from "@/components/KnowledgeBaseMindMap";

export default function SecurityCameraSolutions() {
  const { t } = useTranslation();

  useEffect(() => {
    AOS.init({
      offset: 100,
      easing: "ease-out-back",
      duration: 1000,
      delay: 100,
    });
  }, []);

  return (
    <>
      <Helmet>
        <title>{t("securityCamera.title")}</title>
        <meta name="keywords" content={t("securityCamera.keywords")} />
        <meta name="description" content={t("securityCamera.description")} />
      </Helmet>
      <ContactFloat />

      <section
        className="w-full bg-[#1a2d42]"
        data-aos="fade-right"
        data-aos-offset="100"
        data-aos-duration="500"
      >
        <div className="relative isolate h-[400px] w-full overflow-hidden">
          <img
            src="/solutions/security-camera-banner.jpeg"
            alt=""
            className="absolute inset-0 h-full w-full object-cover object-[50%_18%]"
          />
          <div className="absolute inset-0 bg-linear-to-r from-[#0f1f30]/92 via-[#0f1f30]/72 to-[#0f1f30]/62" />
          <div className="relative z-10 grid h-full w-1200 place-items-center px-4 text-center">
            <div>
              <h2
                className="text-[30px] leading-snug font-bold text-white"
                data-aos="fade-right"
                data-aos-offset="100"
                data-aos-duration="500"
              >
                {t("securityCamera.banner.title")}
              </h2>
              <span
                className="mx-auto mt-3 block h-[4px] w-[50px] bg-white"
                data-aos="zoom-in"
                data-aos-delay="300"
              />
              <p
                className="mt-5 text-base text-white/90 md:text-lg"
                data-aos="fade-left"
                data-aos-offset="100"
                data-aos-duration="500"
              >
                {t("securityCamera.banner.subtitle")}
              </p>
            </div>
          </div>
        </div>
      </section>

      <KnowledgeBaseMindMap
        rootLabel={t("securityCamera.knowledgeBase.rootLabel")}
        rootColor="#0369a1"
        treeTranslationKey="securityCamera.knowledgeBase.tree"
        i18nPrefix="securityCamera.knowledgeBase"
      />

      <IndustrySolutionSections
        i18nPrefix="securityCamera"
        images={{
          painPoints: "/solutions/security-camera-pain.jpeg",
          solutions: "/solutions/security-camera-solutions.jpeg",
          cta: "/solutions/security-camera-cta.jpeg",
        }}
        imagesPos={{
          painPoints: "72% 22%",
          solutions: "50% 28%",
          cta: "50% 18%",
        }}
      />
    </>
  );
}
